import { BOA_KEY, donationsUrls, VERSION } from "../../constants/ApiUrls";
import { getData, updateData } from "../../networkManager/NetworkManager";

export const getAllDonations = async (id) => {
  return await getData(
    BOA_KEY + VERSION + `${id}/${donationsUrls.DONATIONS_LIST}`
  );
};

export const updateDonations = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${donationsUrls.SAVE_DONATIONS}`,
    data
  );
};
